import { JSX, createContext, useContext, Show } from 'solid-js';
import { Portal } from 'solid-js/web';
import { css } from '@emotion/css';
import { Selector } from 'Shared/backend/styles/Selector';


/*
	The editor for one standard style in the component's Styles list: the value control(s) here, and
	the 'Apply to' picker portaled up onto the style's label row (see StylesField in Styles.tsx). It
	goes up there rather than inline so it stays clear of the value, but it is portaled rather than
	pinned so that its path builder, when open, takes real space and pushes the next style down.

	'SelectorSlot' carries the label-row element to portal into. Only StylesField provides it; every
	standard style's ui component (Colour, FontSize, Borders, ...) is this shape, so the picker is
	assembled here rather than repeated in each.
*/

export const SelectorSlot = createContext<{node?: HTMLElement}>();

const valueStyle = css({
	display:       'flex',
	flexDirection: 'column',
	gap:           '0.5em',
});

export function StyleFieldsRow(P:{children:JSX.Element})
{
	const slot = useContext(SelectorSlot);

	return (<>
		<div class={valueStyle}>{P.children}</div>
		<Show when={slot?.node}>
			<Portal mount={slot!.node}><Selector /></Portal>
		</Show>
	</>);
}
